import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/store.js'

import HomeFrame from '@/views/HomeFrame.vue'
import Home from '@/views/Home.vue'

const routes = [
    {
        path: '/',
        component: HomeFrame,
        children: [
            {
                path: '',
                name: 'home',
                component: Home,
            },

            {
                path: 'page/mi-az-a-cityapp',
                component: () => import('@/views/Page/MiAzACityapp.vue'),
            },
            {
                path: 'page/kozlekedesi-mobiljegy',
                component: () => import('@/views/Page/KozlekedesiMobiljegy.vue'),
            },
            {
                path: 'city-manager/login',
                component: () => import('@/views/CityManager/Login.vue'),
            },
            {
                path: 'city-manager/forgot-password',
                component: () => import('@/views/CityManager/ForgotPassword.vue'),
            },
            {
                path: 'city-manager',
                component: () => import('@/views/CityManager/Dashboard.vue'),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: 'city-manager/cities',
                component: () => import('@/views/CityManager/Cities.vue'),
                meta: {
                    isSuperVisor: true,
                },
            },
            {
                path: 'city-manager/cities/new',
                component: () => import('@/views/CityManager/CitiesEditorNew.vue'),
                meta: {
                    isSuperVisor: true,
                },
            },
            {
                path: 'city-manager/cities/:id',
                component: () => import('@/views/CityManager/CitiesEditor.vue'),
                meta: {
                    isSuperVisor: true,
                },
            },
            {
                path: 'city-manager/policydocuments',
                component: () => import('@/views/CityManager/Policydocuments.vue'),
                meta: {
                    isSuperVisor: true,
                },
            },
            {
                path: 'city-manager/policydocuments/new',
                component: () => import('@/views/CityManager/PolicydocumentsNew.vue'),
                meta: {
                    isSuperVisor: true,
                },
            },
            {
                path: 'city-manager/change-password',
                component: () => import('@/views/CityManager/ChangePassword.vue'),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: 'city-manager/users',
                component: () => import('@/views/CityManager/Users/Users.vue'),
                meta: {
                    isSuperVisor: true,
                    defaultSupervisor: true,
                },
            },
            {
                path: 'city-manager/users/new',
                component: () => import('@/views/CityManager/Users/AddUser.vue'),
                meta: {
                    isSuperVisor: true,
                    defaultSupervisor: true,
                },
            },
            {
                path: 'city-manager/users/:id',
                component: () => import('@/views/CityManager/Users/EditUser.vue'),
                meta: {
                    isSuperVisor: true,
                    defaultSupervisor: true,
                },
            },
            {
                path: 'city-manager/statistics',
                component: () => import('@/views/CityManager/Statistics.vue'),
                meta: {
                    requiresAuth: true,
                    hasCityManagerPermission: 'city_stat',
                },
            },
            {
                path: 'city-manager/registrations',
                component: () => import('@/views/CityManager/Registrations/Registrations.vue'),
                meta: {
                    requiresAuth: true,
                    hasCityManagerPermission: 'module_admin',
                },
            },
            {
                path: 'city-manager/modules-of-city',
                component: () => import('@/views/CityManager/CityModules.vue'),
                meta: {
                    isSuperVisor: true,
                    defaultSupervisor: true,
                },
            },
            {
                path: 'city-manager/modules-of-city/:id',
                component: () => import('@/views/CityManager/EditCityModule.vue'),
                meta: {
                    isSuperVisor: true,
                    defaultSupervisor: true,
                },
            },
            {
                path: 'city-manager/payment-params',
                component: () => import('@/views/CityManager/PaymentParameters.vue'),
                meta: {
                    isSuperVisor: true,
                    defaultSupervisor: true,
                },
            },
            {
                path: 'city-manager/payment-params/:id',
                component: () => import('@/views/CityManager/EditPaymentParameter.vue'),
                meta: {
                    isSuperVisor: true,
                    defaultSupervisor: true,
                },
            },
            {
                path: 'city-manager/registrations/:id',
                name: 'cityManagerRegistrationProfileView',
                component: () => import('@/views/CityManager/Registrations/RegistrationProfileView.vue'),
                meta: {
                    requiresAuth: true,
                    hasCityManagerPermission: 'module_admin',
                },
            },
            {
                path: 'city-manager/registrations/:id/product-purchases',
                name: 'cityManagerUserTransportMobileTicketProductPurchases',
                component: () => import('@/views/CityManager/Registrations/TransportMobileTicketModule/UserProductPurchases.vue'),
                meta: {
                    requiresAuth: true,
                    hasCityManagerPermission: 'tmt_ticket_purchases',
                },
            },
            {
                path: 'city-manager/registrations/:id/transport-mobile-ticket-bills',
                name: 'cityManagerUserTransportMobileTicketBills',
                component: () => import('@/views/CityManager/Registrations/TransportMobileTicketModule/UserBills.vue'),
                meta: {
                    requiresAuth: true,
                    hasCityManagerPermission: 'tmt_invoices',
                },
            },
            {
                path: 'city-manager/registrations/:id/transport-mobile-ticket-balance',
                name: 'cityManagerUserTransportMobileTicketBalance',
                component: () => import('@/views/CityManager/Registrations/TransportMobileTicketModule/UserBalance.vue'),
                meta: {
                    requiresAuth: true,
                    hasCityManagerPermission: 'tmt_nmfr_balance',
                },
            },
            {
                path: 'city-manager/registrations/:id/transport-mobile-ticket-parking',
                name: 'cityManagerUserTransportMobileTicketParking',
                component: () => import('@/views/CityManager/Registrations/TransportMobileTicketModule/UserParking.vue'),
                meta: {
                    requiresAuth: true,
                    hasCityManagerPermission: 'tmt_nmfr_parking',
                },
            },
            {
                path: 'city-manager/transport-mobile-ticket/nmfr-balance',
                name: 'cityManagerTransportMobileTicketNMFRBalance',
                component: () => import('@/views/CityManager/TransportMobileticket/NmfrBalance.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'tmt_nmfr_balance'
                },
            },
            {
                path: 'city-manager/transport-mobile-ticket/product-purchases',
                name: 'cityManagerTransportMobileTicketProductPurchases',
                component: () => import('@/views/CityManager/TransportMobileticket/ProductPurchases.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'tmt_ticket_purchases'
                },
            },
            {
                path: 'city-manager/vignette/vignette-purchases',
                name: 'cityManagerVignettePurchases',
                component: () => import('@/views/CityManager/Vignette/VignettePurchases.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'tmt_ticket_purchases'
                },
            },
            {
                path: 'city-manager/transport-mobile-ticket/bills',
                name: 'cityManagerTransportMobileTicketBills',
                component: () => import('@/views/CityManager/TransportMobileticket/Bills.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'tmt_invoices'
                },
            },
            {
                path: 'city-manager/transport-mobile-ticket/nmfr-log',
                name: 'cityManagerTransportMobileTicketNMFRLog',
                component: () => import('@/views/CityManager/TransportMobileticket/NmfrLog.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'tmt_nmfr_logs'
                },
            },
            {
                path: 'city-manager/transport-mobile-ticket/credit-card-payments',
                name: 'cityManagerTransportMobileTicketCreditCardPayments',
                component: () => import('@/views/CityManager/TransportMobileticket/CreditCardPayments.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'tmt_bankcard_payments'
                },
            },
            {
                path: 'city-manager/parking/parking-purchases',
                name: 'cityManagerParkingPurchases',
                component: () => import('@/views/CityManager/Parking/ParkingPurchases.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'tmt_parkings'
                },
            },
        ]
    },

    {
        path: '/:cityName',
        component: () => import('@/views/CityHomeFrame.vue'),
        meta: {
            checkCity: true,
        },
        children: [
            {
                path: '',
                name: 'cityHome',
                component: () => import('@/views/CityHome.vue'),
            },
            {
                path: 'page/kapcsolat',
                component: () => import('@/views/Page/Kapcsolat.vue'),
            },
            {
                path: 'page/:id',
                component: () => import('@/views/Page/BlogPage.vue'),
            },
        ]
    },


    {
        path: '/:cityName/admin',
        component: () => import('@/views/AdminHome.vue'),
        name: 'adminHome',
        meta: {
            checkCity: true,
        },
        children: [
            {
                path: 'reset/password',
                component: () => import('@/views/Password/Reset.vue'),
                requiresAuth: false,
            },
            {
                path: 'login',
                name: 'login',
                component: () => import('@/views/Login.vue'),
                meta: {
                    requiresAuth: false,
                }
            },
            {
                path: 'activate/:token',
                component: () => import('@/views/Activate.vue'),
                meta: {
                    requiresAuth: false,
                }
            },
            {
                path: 'registration',
                component: () => import('@/views/Registration.vue'),
                meta: {
                    requiresAuth: false,
                }
            },
            {
                path: 'businesses',
                component: () => import('@/views/Businesses/Businesses.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'businesses'
                },
            },
            {
                path: 'businesses/new',
                component: () => import('@/views/Businesses/BusinessesEditor.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'businesses'
                },
            },
            {
                path: 'businesses/edit/:id',
                component: () => import('@/views/Businesses/BusinessesEditor.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'businesses'
                },
            },
            {
                path: 'daily-menu',
                component: () => import('@/views/DailyMenu/DailyMenu.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'catering_menus'
                },
            },
            {
                path: 'daily-menu/new/:id',
                component: () => import('@/views/DailyMenu/DailyMenuNew.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'catering_menus'
                },
            },
            {
                path: 'daily-menu/edit/:id',
                component: () => import('@/views/DailyMenu/DailyMenuEditor.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'catering_menus'
                },
            },
            {
                path: 'change-password',
                component: () => import('@/views/Password/ChangePassword.vue'),
                name: 'changePasswordHome',
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'notifications',
                component: () => import('@/views/Notification/Notifications.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'notifications'
                },
            },
            {
                path: 'notifications/new',
                component: () => import('@/views/Notification/NotificationsEditor.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'notifications'
                },
            },
            {
                path: 'notifications/edit/:id',
                component: () => import('@/views/Notification/NotificationsEditor.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'notifications'
                },
            },
            {
                path: 'banners',
                component: () => import('@/views/Banner/Banners.vue'),
                name: 'bannersHome',
                meta: {
                    requiresAuth: true,
                    hasPermission: 'banners'
                },
            },
            {
                path: 'banners/new',
                component: () => import('@/views/Banner/BannersEditor.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'banners'
                },
            },
            {
                path: 'banners/edit/:id',
                component: () => import('@/views/Banner/BannersEditor.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'banners'
                },
            },
            {
                path: 'banners/order',
                component: () => import('@/views/Banner/BannersOrder.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'banners'
                },
            },
            {
                path: 'rss',
                component: () => import('@/views/Rss/Rss.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'rss'
                },
                children: [
                    {
                        path: 'list',
                        component: () => import('@/views/Rss/RssList.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'rss'
                        },
                    },
                    {
                        path: 'sources',
                        component: () => import('@/views/Rss/Sources.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'rss'
                        },
                    },
                    {
                        path: 'sources/edit/:id',
                        component: () => import('@/views/Rss/SourceEdit.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'rss'
                        },
                    },
                    {
                        path: 'categories',
                        component: () => import('@/views/Rss/Categories.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'rss'
                        },
                    },
                    {
                        path: 'categories/news/edit/:id',
                        component: () => import('@/views/Rss/CategoriesEdit.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'rss'
                        },
                    },
                    {
                        path: 'categories/events/edit/:id',
                        component: () => import('@/views/Rss/CategoriesEdit.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'rss'
                        },
                    },
                    {
                        path: 'news',
                        component: () => import('@/views/Rss/NewsList.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'rss'
                        },
                    },
                    {
                        path: 'events',
                        component: () => import('@/views/Rss/EventsList.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'rss'
                        },
                    },
                    {
                        path: 'add-new-news',
                        component: () => import('@/views/Rss/AddNewNews.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'rss'
                        },
                    },
                    {
                        path: 'add-new-event',
                        component: () => import('@/views/Rss/AddNewEvent.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'rss'
                        },
                    },
                ]
            },
            {
                path: 'users/manage',
                component: () => import('@/views/User/UserManage.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'users'
                },
            },
            {
                path: 'users/edit/:id',
                component: () => import('@/views/User/UserEdit.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'users'
                },
            },
            {
                path: 'app-settings',
                component: () => import('@/views/AppSettings/AppSettings.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'app_customization'
                },
                children: [
                    {
                        path: 'menu',
                        component: () => import('@/views/AppSettings/Menu.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'app_customization'
                        }
                    },
                    {
                        path: 'menu/new',
                        component: () => import('@/views/AppSettings/MenuEditor.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'app_customization'
                        }
                    },
                    {
                        path: 'menu/edit/:id',
                        component: () => import('@/views/AppSettings/MenuEditor.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'app_customization'
                        }
                    },
                    {
                        path: 'menu/order',
                        component: () => import('@/views/AppSettings/MenuOrder.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'app_customization'
                        }
                    },
                    {
                        path: 'categories',
                        component: () => import('@/views/AppSettings/Categories.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'app_customization'
                        }
                    },
                    {
                        path: 'categories/new',
                        component: () => import('@/views/AppSettings/CategoriesEditor.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'app_customization'
                        }
                    },
                    {
                        path: 'categories/edit/:id',
                        component: () => import('@/views/AppSettings/CategoriesEditor.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'app_customization'
                        }
                    },
                    {
                        path: 'categories/order',
                        component: () => import('@/views/AppSettings/CategoriesOrder.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'app_customization'
                        }
                    },
                    {
                        path: 'details',
                        component: () => import('@/views/AppSettings/Details.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'app_customization'
                        }
                    },
                    {
                        path: 'details/new',
                        component: () => import('@/views/AppSettings/DetailsEditor.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'app_customization'
                        }
                    },
                    {
                        path: 'details/order',
                        component: () => import('@/views/AppSettings/DetailsOrder.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'app_customization'
                        }
                    },
                    {
                        path: 'details/edit/:id',
                        component: () => import('@/views/AppSettings/DetailsEditor.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'app_customization'
                        }
                    },
                    {
                        path: 'background',
                        component: () => import('@/views/AppSettings/Background.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'app_customization'
                        }
                    },
                    {
                        path: 'background-profile',
                        component: () => import('@/views/AppSettings/BackgroundProfile.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'app_customization'
                        }
                    },
                    {
                        path: 'maintenance',
                        component: () => import('@/views/AppSettings/Maintenance.vue'),
                        meta: {
                            requiresAuth: true,
                            hasPermission: 'app_customization'
                        }
                    },
                ]
            },
            {
                path: 'page/',
                component: () => import('@/views/Pages/Pages.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'web_customization'
                },
            },
            {
                path: 'pages',
                component: () => import('@/views/Pages/Pages.vue'),
                name: 'pagesHome',
                meta: {
                    requiresAuth: true,
                    hasPermission: 'web_customization'
                },
            },
            {
                path: 'pages/new',
                component: () => import('@/views/Pages/PagesEditor.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'web_customization'
                },
            },
            {
                path: 'pages/edit/:id',
                component: () => import('@/views/Pages/PagesEditor.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'web_customization'
                },
            },
            {
                path: 'registrations',
                component: () => import('@/views/Registrations/RegistrationsView.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'module_admin'
                },
            },
            {
                path: 'registrations/:id',
                name: 'registrationProfileView',
                component: () => import('@/views/Registrations/RegistrationProfileView.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'module_admin'
                },
            },
            {
                path: 'city-reports',
                component: () => import('@/views/CityReports/CityReportsView.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_report'
                },
            },
            {
                path: 'city-reports/:id',
                component: () => import('@/views/CityReports/CityReportsDetailView.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_report'
                },
            },
            {
                path: 'city-reports-types',
                component: () => import('@/views/CityReports/CityReportsTypesView.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_type'
                },
            },
            {
                path: 'city-reports-types-upload',
                component: () => import('@/views/CityReports/CityReportsTypesAdd.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_type'
                },
            },
            {
                path: 'city-reports-types/:id',
                component: () => import('@/views/CityReports/CityReportsTypeDetailView.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_type'
                },
            },
            {
                path: 'reports/group',
                component: () => import('@/views/CityReports/CityReportsGroupsView.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_group'
                },
            },
            {
                path: 'reports/group/new',
                component: () => import('@/views/CityReports/CityReportsGroupsAdd.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_group'
                },
            },
            {
                path: 'reports/group/edit/:id',
                component: () => import('@/views/CityReports/CityReportsGroupsAdd.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_group'
                },
            },
            {
                path: 'city-reports-statuses',
                component: () => import('@/views/CityReports/CityReportsStatusesView.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_status'
                },
            },
            {
                path: 'city-reports-statuses/new',
                component: () => import('@/views/CityReports/CityReportsStatusesEditor.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_status'
                },
            },
            {
                path: 'city-reports-statuses/edit/:id',
                component: () => import('@/views/CityReports/CityReportsStatusesEditor.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_status'
                },
            },
            {
                path: 'city-reports-companies',
                component: () => import('@/views/CityReports/CityReportsCompaniesView.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_company'
                },
            },
            {
                path: 'city-reports-companies-upload',
                component: () => import('@/views/CityReports/CityReportsCompaniesUploadView.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_company'
                },
            },
            {
                path: 'city-reports-companies/:id',
                component: () => import('@/views/CityReports/CityReportsCompaniesDetailView.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_company'
                },
            },
            {
                path: 'city-report-statistics/types',
                component: () => import('@/views/CityReports/Statistics/ModulesStatisticsTypes.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_stat_type'
                },
            },
            {
                path: 'city-report-statistics/reports',
                component: () => import('@/views/CityReports/Statistics/ModulesStatisticsReports.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_stat_reports'
                },
            },
            {
                path: 'city-report-statistics/companies',
                component: () => import('@/views/CityReports/Statistics/ModulesStatisticsCompanies.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_stat_company'
                },
            },
            {
                path: 'city-report-statistics/map',
                component: () => import('@/views/CityReports/Statistics/ModulesStatisticsMap.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cr_stat_map'
                },
            },
            {
                path: 'city-card-payment',
                component: () => import('@/views/CityCard/Payment.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cc_payment'
                },
            },
            {
                path: 'city-card-statistics/payment',
                component: () => import('@/views/CityCard/Statistics/ModuleStatisticsPayment.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'cc_stat_payment'
                },
            },
            {
                path: 'logs',
                component: () => import('@/views/Logs/LogsView.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'module_admin'
                },
            },
            {
                path: 'parameters',
                component: () => import('@/views/Parameters/Parameters.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'parameters'
                },
            },
            {
                path: 'statistics',
                component: () => import('@/views/Statistics/Statistics.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'city_stat'
                },
            },
            // {
            //     path: 'transport-mobile-ticket/nmfr-balance',
            //     component: () => import('@/views/TransportMobileticket/NmfrBalance.vue'),
            //     meta: {
            //         requiresAuth: true,
            //         hasPermission: 'tmt_nmfr_balance'
            //     },
            // },
            // {
            //     path: 'transport-mobile-ticket/product-purchases',
            //     component: () => import('@/views/TransportMobileticket/ProductPurchases.vue'),
            //     meta: {
            //         requiresAuth: true,
            //         hasPermission: 'tmt_ticket_purchases'
            //     },
            // },
            // {
            //     path: 'transport-mobile-ticket/bills',
            //     component: () => import('@/views/TransportMobileticket/Bills.vue'),
            //     meta: {
            //         requiresAuth: true,
            //         hasPermission: 'tmt_invoices'
            //     },
            // },
            // {
            //     path: 'transport-mobile-ticket/nmfr-log',
            //     component: () => import('@/views/TransportMobileticket/NmfrLog.vue'),
            //     meta: {
            //         requiresAuth: true,
            //         hasPermission: 'tmt_nmfr_logs'
            //     },
            // },
            {
                path: 'registrations/:id/product-purchases',
                name: 'userTransportMobileTicketProductPurchases',
                component: () => import('@/views/Registrations/TransportMobileTicketModule/UserProductPurchases.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'tmt_ticket_purchases'
                },
            },
            {
                path: 'registrations/:id/transport-mobile-ticket-bills',
                component: () => import('@/views/Registrations/TransportMobileTicketModule/UserBills.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'tmt_invoices'
                },
            },
            {
                path: 'registrations/:id/transport-mobile-ticket-balance',
                name: 'userTransportMobileTicketBalance',
                component: () => import('@/views/Registrations/TransportMobileTicketModule/UserBalance.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'tmt_nmfr_balance'
                },
            },
            {
                path: 'registrations/:id/transport-mobile-ticket-parking',
                name: 'userTransportMobileTicketParking',
                component: () => import('@/views/Registrations/TransportMobileTicketModule/UserParking.vue'),
                meta: {
                    requiresAuth: true,
                    hasPermission: 'tmt_nmfr_parking'
                },
            },
            // {
            //     path: 'transport-mobile-ticket/credit-card-payments',
            //     component: () => import('@/views/TransportMobileticket/CreditCardPayments.vue'),
            //     meta: {
            //         requiresAuth: true,
            //         hasPermission: 'tmt_bankcard_payments'
            //     },
            // },
        ]
    }

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {

    // 1. Először megnézzük a checkCity-t. Ha false, elküldjük "/"-re.
    // 2. Ha nem false, akkor jön a következő if. Ha requiresAuth az false, akkor elküldjük
    //     a "/admin/login"-ra.
    // 3. Ha nem false, akkor a hasPermission értékét vizsgáljuk meg. Ha ez egy olyan string,
    //     ami szerepel a userData.permissions kulcsai közt és annak az értéke nem 1,
    //     akkor elküldjük a "/admin"-ra. Ha ez is true akkor next().
    // 4. Ha nem false, megnézzük, hogy a kiválasztott modul státusza aktív-e.

    let cityName = to.params.cityName
    let selectedCity = store.getters.selectedCity(cityName)

    // if(to.matched.some(record => record.meta.checkManager)) {
    //     if (store.getters.isLoggedIn != true) {
    //         next({ path: `/${to.params.cityName}/admin/login`});
    //     }
    // }

    if (to.matched.some(record => record.meta.checkCity)) {
        if (cityName != selectedCity.slub) {
            // Ha már be van lépve de nem jó az általa megadott város név (pl, nem létezik vagy nincs oda belépve)
            // akkor dobjuk vissza a saját város admin felületére
            // Kivéve ha supervisor-ról van szó mert akkor vissza kell őt dobni a cityManager-re
            if (store.getters.isLoggedIn == true) {

                if (store.getters.userData.permissions.permission_level == 'supervisor') {
                    next({ path: '/city-manager/cities' })
                } else {
                    next({ path: `/${selectedCity.slub}/admin` });
                }
            } else {
                next({ path: '/' });
            }
        }
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn != true) {
            next({ path: `/${to.params.cityName}/admin/login` });
        }
    }

    if (to.matched.some(record => record.meta.hasPermission)) {
        if (!(to.meta.hasPermission in store.getters.userData.permissions)) {
            next({ path: `/${to.params.cityName}/admin` });
        }
        if (store.getters.userData.permissions[to.meta.hasPermission] != 1) {
            next({ path: `/${to.params.cityName}/admin` });
        }
    }

    if (to.matched.some(record => record.meta.isSuperVisor)) {
        if (store.getters.isLoggedIn != true) {
            next({ path: '/city-manager/login' });
        } else if (store.getters.userData.permissions.permission_level != 'supervisor') {
            next({ path: `/city-manager/login` });
        }
    }

    if (to.matched.some(record => record.meta.defaultSupervisor)) {
        if (store.getters.isLoggedIn != true) {
            next({ path: '/city-manager/login' });
        } else if (store.getters.userData.email != 'supervisor@hws.hu') {
            next({ path: `/city-manager/users` });
        }
    }

    if (to.matched.some(record => record.meta.hasCityManagerPermission)) {
        if (
            !(to.meta.hasCityManagerPermission in store.getters.userData.permissions) &&
            store.getters.userData.permissions.permission_level != 'supervisor'
        ) {
            next({ path: '/city-manager/login' });
        }
        if (
            store.getters.userData.permissions[to.meta.hasCityManagerPermission] != 1 &&
            store.getters.userData.permissions.permission_level != 'supervisor'
        ) {
            next({ path: '/city-manager/login' });
        }
    }

    next();
})

export default router